<template>
  <div class="page">
    <OpdrachtenHeader
      @showVoegOpdrachtToeModal="$emit('showVoegOpdrachtToeModal')"
    />

    <div class="page-wrapper">
      <!-- NIEUWE OPDRACHTEN -->
      <!-- <div class="listholder">
        <h3 class="listtitle">Nieuwe opdrachten</h3>
        <OpdrItemsHeaderNieuw />
        <div
          v-for="opdracht in orderBy(filteredNieuweOpdrachten, 'opdrachtnummer', -1)"
          :key="opdracht.id"
          v-on:click="$emit('select-opdracht', opdracht.id)"
        >
          <OpdrachtItemNieuw :opdracht="opdracht" />
        </div>
      </div> -->

      <!-- OLD TOGGLES -->
      <!-- <div class="toggleholder">
        <div class="filtertoggle" style="padding-right:25px;">
          <ToggleButton :value="showOpdrFilters" @change="toggleShowOpdrFilters" :width="40" color="#3076EA" />
          <span v-if="showOpdrFilters == false" class="filter">Filters</span>
          <span v-if="showOpdrFilters" class="filter" style="color:#3076EA;">Filters</span>
        </div>

        <div class="filtertoggle" style="padding-right:25px;">
          <ToggleButton :value="showOpdrOnHold" @change="toggleShowOpdrOnHold" :width="40" color="#FF9326" />
          <span v-if="showOpdrOnHold == false" class="filter">On Hold</span>
          <span v-if="showOpdrOnHold" class="filter" style="color:#FF9326;">On Hold</span>
        </div>

        <div class="filtertoggle" style="padding-right:25px;">
          <ToggleButton :value="showOpdrGeannuleerd" @change="toggleShowOpdrGeannuleerd" :width="40" color="#F1646C" />
          <span v-if="showOpdrGeannuleerd == false" class="filter">Geannuleerd</span>
          <span v-if="showOpdrGeannuleerd" class="filter" style="color:#F1646C;">Geannuleerd</span>
        </div>

        <div class="filtertoggle">
          <ToggleButton :value="showOpdrBeëindigd" @change="toggleShowOpdrBeeindigd" :width="40" color="#35DD83" />
          <span v-if="showOpdrBeëindigd == false" class="filter">Beëindigd</span>
          <span v-if="showOpdrBeëindigd" class="filter" style="color:#35DD83 !important;">Beëindigd</span>
        </div>
      </div> -->

      <!-- selectors -->
      <div class="selectorsContainer">
        <div class="container">
          <div
            class="selector"
            @click="listselector = 'nieuw'"
            :class="{ activeList: listselector == 'nieuw' }"
          >
            Nieuw
          </div>
        </div>
        <div class="container">
          <div
            class="selector"
            @click="listselector = 'alle'"
            :class="{ activeList: listselector == 'alle' }"
          >
            Alle
          </div>
          <div
            class="selector"
            @click="listselector = 'geaccepteerd'"
            :class="{ activeList: listselector == 'geaccepteerd' }"
          >
            Geaccepteerd
          </div>
          <div
            class="selector"
            @click="listselector = 'gestart'"
            :class="{ activeList: listselector == 'gestart' }"
          >
            Gestart
          </div>
          <div
            class="selector"
            @click="listselector = 'beëindigd'"
            :class="{ activeList: listselector == 'beëindigd' }"
          >
            Beëindigd
          </div>
        </div>
        <div class="container">
          <div
            class="selector"
            @click="listselector = 'onhold'"
            :class="{ activeListOrange: listselector == 'onhold' }"
          >
            On Hold
          </div>
          <div
            class="selector"
            @click="listselector = 'geannuleerd'"
            :class="{ activeListRed: listselector == 'geannuleerd' }"
          >
            Geannuleerd
          </div>
        </div>
      </div>

      <div class="listholder">
        <OpdrItemsHeader v-if="listselector != 'nieuw'" />
        <OpdrItemsHeaderNieuw v-if="listselector == 'nieuw'" />
        <div v-if="listselector == 'nieuw'">
          <div
            v-for="opdracht in orderBy(
              filteredNieuweOpdrachten,
              'opdrachtnummer',
              -1
            )"
            :key="opdracht.id"
            @click="$emit('select-opdracht', opdracht.id)"
          >
            <OpdrachtItemNieuw :opdracht="opdracht" />
          </div>
        </div>
        <div v-if="listselector == 'alle'">
          <div
            v-for="opdracht in orderBy(
              filteredOpdrachten,
              'opdrachtnummer',
              -1
            )"
            :key="opdracht.id"
            @click="$emit('select-opdracht', opdracht.id)"
          >
            <OpdrachtItem :opdracht="opdracht" />
          </div>
        </div>
        <div v-if="listselector == 'geaccepteerd'">
          <div
            v-for="opdracht in orderBy(
              filteredOpdrachtenGeaccepteerd,
              'opdrachtnummer',
              -1
            )"
            :key="opdracht.id"
            @click="$emit('select-opdracht', opdracht.id)"
          >
            <OpdrachtItem :opdracht="opdracht" />
          </div>
        </div>
        <div v-if="listselector == 'gestart'">
          <div
            v-for="opdracht in orderBy(
              filteredOpdrachtenGestart,
              'opdrachtnummer',
              -1
            )"
            :key="opdracht.id"
            @click="$emit('select-opdracht', opdracht.id)"
          >
            <OpdrachtItem :opdracht="opdracht" />
          </div>
        </div>
        <div v-if="listselector == 'beëindigd'">
          <div
            v-for="opdracht in orderBy(
              filteredOpdrachtenBeëindigd,
              'opdrachtnummer',
              -1
            )"
            :key="opdracht.id"
            @click="$emit('select-opdracht', opdracht.id)"
          >
            <OpdrachtItem :opdracht="opdracht" />
          </div>
        </div>

        <div v-if="listselector == 'onhold'">
          <div
            v-for="opdracht in orderBy(
              filteredOnHoldOpdrachten,
              'opdrachtnummer',
              -1
            )"
            :key="opdracht.id"
            @click="$emit('select-opdracht', opdracht.id)"
          >
            <OpdrachtItem :opdracht="opdracht" />
          </div>
        </div>
        <div v-if="listselector == 'geannuleerd'">
          <div
            v-for="opdracht in orderBy(
              filteredGeannuleerdeOpdrachten,
              'opdrachtnummer',
              -1
            )"
            :key="opdracht.id"
            @click="$emit('select-opdracht', opdracht.id)"
          >
            <OpdrachtItem :opdracht="opdracht" />
          </div>
        </div>
      </div>

      <!-- <div class="listholder">
        <OpdrItemsHeader />
        <div v-if="showOpdrOnHold != true && showOpdrGeannuleerd != true && showOpdrBeëindigd != true">
          <div
            v-for="opdracht in orderBy(filteredOpdrachten, 'opdrachtnummer', -1)"
            :key="opdracht.id"
            v-on:click="$emit('select-opdracht', opdracht.id)"
          >
            <OpdrachtItem :opdracht="opdracht" />
          </div>
        </div>

        <div v-if="showOpdrOnHold">
          <div
            v-for="opdracht in orderBy(filteredOnHoldOpdrachten, 'opdrachtnummer', -1)"
            :key="opdracht.id"
            v-on:click="$emit('select-opdracht', opdracht.id)"
          >
            <OpdrachtItem :opdracht="opdracht" />
          </div>
        </div>

        <div v-if="showOpdrGeannuleerd">
          <div
            v-for="opdracht in orderBy(filteredGeannuleerdeOpdrachten, 'opdrachtnummer', -1)"
            :key="opdracht.id"
            v-on:click="$emit('select-opdracht', opdracht.id)"
          >
            <OpdrachtItem :opdracht="opdracht" />
          </div>
        </div>

        <div v-if="showOpdrBeëindigd">
          <div
            v-for="opdracht in orderBy(filteredBeeindigdeOpdrachten, 'opdrachtnummer', -1)"
            :key="opdracht.id"
            v-on:click="$emit('select-opdracht', opdracht.id)"
          >
            <OpdrachtItem :opdracht="opdracht" />
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'

import Vue2Filters from 'vue2-filters'

import OpdrachtenHeader from './OpdrachtenHeader'
import OpdrItemsHeaderNieuw from './OpdrItemsHeaderNieuw'
import OpdrachtItem from './OpdrachtItem'
import OpdrachtItemNieuw from './OpdrachtItemNieuw'
import OpdrItemsHeader from './OpdrItemsHeader'

export default {
  name: 'opdrachten',
  components: {
    OpdrachtenHeader,
    OpdrachtItem,
    OpdrachtItemNieuw,
    OpdrItemsHeader,
    OpdrItemsHeaderNieuw
  },
  mixins: [Vue2Filters.mixin],
  data () {
    return {
      listselector: 'nieuw'
    }
  },
  computed: {
    ...mapGetters(['allOpdrachten']),

    filteredOpdrachten () {
      return this.allOpdrachten
        .filter(opdracht => !opdracht.geannuleerd)
        .filter(opdracht => {
          const opdrachtnummer = 'CDT.2020.' + opdracht.opdrachtnummer
          return opdrachtnummer
            .toString()
            .toLowerCase()
            .includes(store.state.opdrFilters.opdrachtnummer)
        })
        .filter(opdracht => {
          return opdracht.bedrijfsnaam
            .toLowerCase()
            .includes(store.state.opdrFilters.bedrijfsnaam.toLowerCase())
        })
        .filter(opdracht => {
          return opdracht.status
            .toLowerCase()
            .includes(store.state.opdrFilters.status.toLowerCase())
        })
        .filter(opdracht => {
          if (store.state.opdrFilters.disciplines == '') {
            return opdracht
          } else {
            return opdracht.disciplines.includes(
              store.state.opdrFilters.disciplines
            )
          }
        })
    },

    filteredOpdrachtenGeaccepteerd () {
      return this.allOpdrachten
        .filter(
          opdracht =>
            opdracht.status == 'Geaccepteerd' &&
            !opdracht.geannuleerd &&
            !opdracht.onhold
        )
        .filter(opdracht => {
          const opdrachtnummer = 'CDT.2020.' + opdracht.opdrachtnummer
          return opdrachtnummer
            .toString()
            .toLowerCase()
            .includes(store.state.opdrFilters.opdrachtnummer)
        })
        .filter(opdracht => {
          return opdracht.bedrijfsnaam
            .toLowerCase()
            .includes(store.state.opdrFilters.bedrijfsnaam.toLowerCase())
        })
        .filter(opdracht => {
          return opdracht.status
            .toLowerCase()
            .includes(store.state.opdrFilters.status.toLowerCase())
        })
        .filter(opdracht => {
          if (store.state.opdrFilters.disciplines == '') {
            return opdracht
          } else {
            return opdracht.disciplines.includes(
              store.state.opdrFilters.disciplines
            )
          }
        })
    },

    filteredOpdrachtenGestart () {
      return this.allOpdrachten
        .filter(
          opdracht =>
            opdracht.status == 'Gestart' &&
            !opdracht.geannuleerd &&
            !opdracht.onhold
        )
        .filter(opdracht => {
          const opdrachtnummer = 'CDT.2020.' + opdracht.opdrachtnummer
          return opdrachtnummer
            .toString()
            .toLowerCase()
            .includes(store.state.opdrFilters.opdrachtnummer)
        })
        .filter(opdracht => {
          return opdracht.bedrijfsnaam
            .toLowerCase()
            .includes(store.state.opdrFilters.bedrijfsnaam.toLowerCase())
        })
        .filter(opdracht => {
          return opdracht.status
            .toLowerCase()
            .includes(store.state.opdrFilters.status.toLowerCase())
        })
        .filter(opdracht => {
          if (store.state.opdrFilters.disciplines == '') {
            return opdracht
          } else {
            return opdracht.disciplines.includes(
              store.state.opdrFilters.disciplines
            )
          }
        })
    },

    filteredOpdrachtenBeëindigd () {
      return this.allOpdrachten
        .filter(opdracht => opdracht.status == 'Beëindigd')
        .filter(opdracht => {
          const opdrachtnummer = 'CDT.2020.' + opdracht.opdrachtnummer
          return opdrachtnummer
            .toString()
            .toLowerCase()
            .includes(store.state.opdrFilters.opdrachtnummer)
        })
        .filter(opdracht => {
          return opdracht.bedrijfsnaam
            .toLowerCase()
            .includes(store.state.opdrFilters.bedrijfsnaam.toLowerCase())
        })
        .filter(opdracht => {
          return opdracht.status
            .toLowerCase()
            .includes(store.state.opdrFilters.status.toLowerCase())
        })
        .filter(opdracht => {
          if (store.state.opdrFilters.disciplines == '') {
            return opdracht
          } else {
            return opdracht.disciplines.includes(
              store.state.opdrFilters.disciplines
            )
          }
        })
        .filter(opdracht => !opdracht.onhold)
    },

    filteredOnHoldOpdrachten () {
      return this.allOpdrachten
        .filter(opdracht => opdracht.onhold == true)
        .filter(opdracht => !opdracht.geannuleerd)
        .filter(opdracht => {
          const opdrachtnummer = 'CDT.2020.' + opdracht.opdrachtnummer
          return opdrachtnummer
            .toString()
            .toLowerCase()
            .includes(store.state.opdrFilters.opdrachtnummer)
        })
        .filter(opdracht => {
          return opdracht.bedrijfsnaam
            .toLowerCase()
            .includes(store.state.opdrFilters.bedrijfsnaam.toLowerCase())
        })
        .filter(opdracht => {
          return opdracht.status
            .toLowerCase()
            .includes(store.state.opdrFilters.status.toLowerCase())
        })
        .filter(opdracht => {
          if (store.state.opdrFilters.disciplines == '') {
            return opdracht
          } else {
            return opdracht.disciplines.includes(
              store.state.opdrFilters.disciplines
            )
          }
        })
    },

    filteredGeannuleerdeOpdrachten () {
      return this.allOpdrachten
        .filter(opdracht => opdracht.geannuleerd == true)
        .filter(opdracht => {
          const opdrachtnummer = 'CDT.2020.' + opdracht.opdrachtnummer
          return opdrachtnummer
            .toString()
            .toLowerCase()
            .includes(store.state.opdrFilters.opdrachtnummer)
        })
        .filter(opdracht => {
          return opdracht.bedrijfsnaam
            .toLowerCase()
            .includes(store.state.opdrFilters.bedrijfsnaam.toLowerCase())
        })
        .filter(opdracht => {
          return opdracht.status
            .toLowerCase()
            .includes(store.state.opdrFilters.status.toLowerCase())
        })
        .filter(opdracht => {
          if (store.state.opdrFilters.disciplines == '') {
            return opdracht
          } else {
            return opdracht.disciplines.includes(
              store.state.opdrFilters.disciplines
            )
          }
        })
    },

    filteredNieuweOpdrachten () {
      return this.allOpdrachten
        .filter(
          opdracht =>
            (opdracht.status == 'Nieuw' && opdracht.onhold != true) ||
            (opdracht.status == 'In behandeling' && opdracht.onhold != true) ||
            opdracht.status == 'Uitgezet'
        )
        .filter(opdracht => opdracht.geannuleerd != true)
        .filter(opdracht => {
          const opdrachtnummer = 'CDT.2020.' + opdracht.opdrachtnummer
          return opdrachtnummer
            .toString()
            .toLowerCase()
            .includes(store.state.opdrFilters.opdrachtnummer)
        })
        .filter(opdracht => {
          return opdracht.bedrijfsnaam
            .toLowerCase()
            .includes(store.state.opdrFilters.bedrijfsnaam.toLowerCase())
        })
        .filter(opdracht => {
          return opdracht.status
            .toLowerCase()
            .includes(store.state.opdrFilters.status.toLowerCase())
        })
        .filter(opdracht => {
          if (store.state.opdrFilters.disciplines == '') {
            return opdracht
          } else {
            return opdracht.disciplines.includes(
              store.state.opdrFilters.disciplines
            )
          }
        })
    },

    filteredUitgezetteOpdrachten () {
      return this.allOpdrachten
        .filter(
          opdracht => opdracht.status == 'Uitgezet' && opdracht.onhold != true
        )
        .filter(opdracht => opdracht.geannuleerd != true)
        .filter(opdracht => {
          const opdrachtnummer = 'CDT.2020.' + opdracht.opdrachtnummer
          return opdrachtnummer
            .toString()
            .toLowerCase()
            .includes(store.state.opdrFilters.opdrachtnummer)
        })
        .filter(opdracht => {
          return opdracht.bedrijfsnaam
            .toLowerCase()
            .includes(store.state.opdrFilters.bedrijfsnaam.toLowerCase())
        })
        .filter(opdracht => {
          return opdracht.status
            .toLowerCase()
            .includes(store.state.opdrFilters.status.toLowerCase())
        })
        .filter(opdracht => {
          if (store.state.opdrFilters.disciplines == '') {
            return opdracht
          } else {
            return opdracht.disciplines.includes(
              store.state.opdrFilters.disciplines
            )
          }
        })
    },

    // filteredTekenaars () {
    //     return this.allTekenaars.filter(tekenaar => {
    //         return tekenaar.naam.toLowerCase().includes(store.state.tekFilters.name.toLowerCase())
    //     }).filter(tekenaar => {
    //         return tekenaar.email.toLowerCase().includes(store.state.tekFilters.email.toLowerCase())
    //     }).filter(tekenaar => {
    //         return tekenaar.telefoonnummer.toLowerCase().includes(store.state.tekFilters.telefoonnummer.toLowerCase())
    //     }).filter(tekenaar => {
    //         if (store.state.tekFilters.disciplines == "") {
    //             return tekenaar
    //         }
    //         else {
    //             return tekenaar.disciplines.includes(store.state.tekFilters.disciplines)
    //         }
    //     }).filter(tekenaar => {
    //         return tekenaar.bedrijfsnaam.toLowerCase().includes(store.state.tekFilters.bedrijfsnaam.toLowerCase())
    //     }).filter(tekenaar => {
    //         return tekenaar.woonplaats.toLowerCase().includes(store.state.tekFilters.woonplaats.toLowerCase())
    //     }).filter(tekenaar => {
    //         return tekenaar.tekenprogramma.toLowerCase().includes(store.state.tekFilters.tekenprogramma.toLowerCase())
    //     })
    // },
    showOpdrFilters () {
      return store.state.showOpdrFilters
    },
    showOpdrOnHold () {
      return store.state.showOpdrOnHold
    },
    showOpdrGeannuleerd () {
      return store.state.showOpdrGeannuleerd
    },
    showOpdrBeëindigd () {
      return store.state.showOpdrBeëindigd
    }
  },
  methods: {
    toggleShowOpdrFilters () {
      store.commit('toggleShowOpdrFilters', this.showOpdrFilters)
    },
    toggleShowOpdrOnHold () {
      store.commit('toggleShowOpdrOnHold', this.showOpdrOnHold)
    },
    toggleShowOpdrGeannuleerd () {
      store.commit('toggleShowOpdrGeannuleerd', this.showOpdrGeannuleerd)
    },
    toggleShowOpdrBeeindigd () {
      store.commit('toggleShowOpdrBeëindigd', this.showOpdrBeëindigd)
    }
  }
}
</script>

<style scoped>
.toggleholder {
  display: flex;
  flex-direction: row;
}

.listholder {
  padding-bottom: 100px;
}
.listtitle {
  font-weight: 600;
  padding-bottom: 20px;
}

.selectorsContainer {
  display: flex;
  flex-direction: row;
  width: fit-content;
  padding-bottom: 30px;
  font-weight: 500;
}

.container {
  display: flex;
  flex-direction: row;
  width: fit-content;
  padding-right: 20px;
}

.selector {
  font-size: 15px;
  padding: 10px 15px;
  border: 1px solid lightgray;
  margin-right: -1px;
  background-color: #fff;
  cursor: pointer;
}
.selector:hover {
  color: #3076ea;
}

.activeList {
  background-color: #3076ea;
  color: #fff !important;
}

.activeListOrange {
  background-color: #ff9326;
  color: #fff !important;
}
.activeListRed {
  background-color: rgb(241, 100, 108);
  color: #fff !important;
}
</style>
